{
  "role": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-220000",
  "definition": "[220000] Statement of financial position, by order of liquidity method",
  "sheetId": "StatementOfFinancialPositionLiquidity",
  "label": "Statement of Financial Position (Liquidity Order)",
  "controls": [
    {
      "qname": "ssmt:StatementOfFinancialPositionLiquidityExplanatory",
      "label": "Statement of Financial Position (Liquidity Order) - Explanatory Notes",
      "type": "TextBlock",
      "ui": {
        "control": "textarea",
        "rows": 4,
        "placeholder": "Enter any explanatory notes for presentation by order of liquidity..."
      },
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:SectionHeaderAssetsLiquidity",
      "label": "ASSETS (by Order of Liquidity)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:CashAndCashEquivalentsLiquidity",
      "label": "Cash and cash equivalents",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        },
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:ShortTermInvestmentsLiquidity",
      "label": "Short-term investments",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TradeReceivablesLiquidity",
      "label": "Trade receivables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        },
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:OtherReceivablesLiquidity",
      "label": "Other receivables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:InventoriesLiquidity",
      "label": "Inventories",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:PrepaymentsLiquidity",
      "label": "Prepayments",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:PropertyPlantAndEquipmentLiquidity",
      "label": "Property, plant and equipment",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        },
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:InvestmentPropertiesLiquidity",
      "label": "Investment properties",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:IntangibleAssetsLiquidity",
      "label": "Intangible assets",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:InvestmentsInSubsidiariesLiquidity",
      "label": "Investments in subsidiaries",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:InvestmentsInAssociatesLiquidity",
      "label": "Investments in associates",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:InvestmentsInJointVenturesLiquidity",
      "label": "Investments in joint ventures",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:LongTermInvestmentsLiquidity",
      "label": "Long-term investments",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:DeferredTaxAssetsLiquidity",
      "label": "Deferred tax assets",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:OtherAssetsLiquidity",
      "label": "Other assets",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TotalAssetsLiquidity",
      "label": "TOTAL ASSETS",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:SectionHeaderLiabilitiesLiquidity",
      "label": "LIABILITIES (by Order of Maturity)",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:BankOverdraftsLiquidity",
      "label": "Bank overdrafts",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TradePayablesLiquidity",
      "label": "Trade payables",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        },
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:OtherPayablesLiquidity",
      "label": "Other payables and accruals",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:ShortTermBorrowingsLiquidity",
      "label": "Short-term borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:CurrentTaxLiabilitiesLiquidity",
      "label": "Current tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:ShortTermProvisionsLiquidity",
      "label": "Short-term provisions",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:LongTermBorrowingsLiquidity",
      "label": "Long-term borrowings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:DeferredTaxLiabilitiesLiquidity",
      "label": "Deferred tax liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:LongTermProvisionsLiquidity",
      "label": "Long-term provisions",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:OtherLiabilitiesLiquidity",
      "label": "Other liabilities",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TotalLiabilitiesLiquidity",
      "label": "TOTAL LIABILITIES",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:SectionHeaderEquityLiquidity",
      "label": "EQUITY",
      "type": "SectionHeader",
      "ui": {
        "control": "header",
        "level": "h3"
      }
    },
    {
      "qname": "ssmt:ShareCapitalLiquidity",
      "label": "Share capital",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        },
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:SharePremiumLiquidity",
      "label": "Share premium",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:RetainedEarningsLiquidity",
      "label": "Retained earnings",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:OtherReservesLiquidity",
      "label": "Other reserves",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "dualColumn": true
      },
      "validators": [
        {
          "name": "min",
          "value": 0
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TotalEquityLiquidity",
      "label": "TOTAL EQUITY",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    },
    {
      "qname": "ssmt:TotalEquityAndLiabilitiesLiquidity",
      "label": "TOTAL EQUITY AND LIABILITIES",
      "type": "MonetaryItemType",
      "ui": {
        "decimalPlaces": 0,
        "control": "number",
        "placeholder": "0",
        "currency": "MYR",
        "readonly": true,
        "calculated": true,
        "dualColumn": true
      },
      "required": true,
      "validators": [
        {
          "name": "required"
        }
      ],
      "ContextPolicy": {
        "periodTemplate": "I_CUR",
        "allowedAxes": []
      }
    }
  ]
}